<template>
    <v-card outlined>
        <v-card-title>
          <div class="mb-1 title">{{data.title}}</div>
        </v-card-title>
        <v-card-subtitle>
          {{publishAt}}
        </v-card-subtitle>
        <v-divider/>
        <v-card-actions>
            <v-btn
                tile
                color="primary"
                @click="editEditorial"
                title="Edit"
                class="mx-2" text
            >
                <v-icon>{{ icons.edit }}</v-icon>
            </v-btn>
            <v-btn
                tile
                color="primary"
                @click.stop="showDeleteDialog=true"
                title="Delete"
                class="mx-2" text
            >
                <v-icon>{{ icons.delete }}</v-icon>
            </v-btn>

        </v-card-actions>
        <DeleteDialog :data="{id:data.id}" :visible="showDeleteDialog" @close="showDeleteDialog=false" @confirmAction="deletingCallback"/>

    </v-card>
</template>
<script>
import DeleteDialog from '@/components/ConfirmDeleteDialog.vue'
import urlUtils from '@/utils/urlUtils'
import postApi from '@/api/postApi'
import snackbar from '@/utils/snackbar'
import { mdiPencil, mdiDelete, mdiClipboardListOutline } from '@mdi/js'

export default {
  components: {
    DeleteDialog
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      icons: {
        edit: mdiPencil,
        delete: mdiDelete,
        article: mdiClipboardListOutline
      },
      showDeleteDialog: false,
      loading: false
    }
  },
  computed: {
    publishAt: {
      get () {
        return this.$moment(this.data.publish_date).format('MMMM Do, YYYY')
      }

    }
  },
  methods: {
    async deletingCallback (data) {
      if (data !== null && data.id !== undefined) {
        const id = data.id
        this.loading = true
        try {
          const result = await postApi.deleteEditorial(id)
          if (result.data === 'success') {
            snackbar.show('Editorial deleted successfully', 'success')
            this.$emit('delete_success')
          }
        } finally {
          this.loading = false
        }
      }
    },
    getFullImageUrl (gw) {
      if (gw.avatar !== null && gw.avatar !== undefined) {
        var k = urlUtils.getImageUrl(gw.avatar.path)
        return k
      }
      return ''
    },
    editEditorial () {
      this.$router.push({ path: '/editorial/edit/' + this.data.id, params: { gw: this.data, id: this.data.id } })
    }
  }
}
</script>
